// extracted by mini-css-extract-plugin
export default {"description":"PopoutAlert_description__WYOu4"};